<template>
  <div id="man_index"></div>
</template>
<script>
import { listContentUserManPermissions, getContentUserManInfo } from '../../../../api/man'
export default {
  name: 'man_index',
  components: {

  },
  created() {
    getContentUserManInfo({
      tenantId: String(this.$commonJs.getTenantId()),
    }).then(res => {
      if (res && res.pin) {
        listContentUserManPermissions({
          tenantId: this.$commonJs.getTenantId()
        }).then(res => {
          if (res) {
            if (res.length > 0) {
              var menu = res[0];
              var url = menu.url ? menu.url : menu.contentPermissionDTOs[0].url;
              this.$router.push({
                path: url,
              });
            } else {
              this.$message.error('对不起，您没有权限！');
            }
          } else {
            this.$message.error('服务器请求错误，请稍后再试！');
          }
        });
      } else {
        this.$router.push({
          path: "/logo",
          query: {
            returnUrl: window.location.href,
          },
        });
      }
    }).catch(error => {
      this.$router.push({
          path: "/logo",
          query: {
            returnUrl: window.location.href,
          },
        });
    })
  }
}

</script>
<style lang="scss">
#man_index {}

</style>
